
export default {
  name: 'Input',
  props: {
    value: {
      type: [String, Number],
      required: true,
      default: '',
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    question: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    computedValue: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
};
